<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <h2>Importar</h2>
  </div>
  <div class="col-lg-2"></div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-content box-content">
          <div class="system-table table-container">
            <div class="system-table-conteiner">
              <table>
                <thead>
                  <tr>
                    <th>Arquivo</th>
                    <th class="text-center btn-icon-td">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of importarIrcp">
                    <td class="title">{{ item?.name }}</td>
                    <td class="btn-icon-td">
                      <div class="btn-icon">
                        <span class="icon-table btn-importar" (click)="openModal(item)">
                          {{ item?.label }}
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-importar-ircp-modal #modal></app-importar-ircp-modal>